import { Box, Icon } from '@factorialco/deprecated-design-system'

export interface IFavouriteButtonProps {
  disabled?: boolean
  isFavourite: boolean
  onChange: (favourite: boolean) => void
}

export const FavouriteButton: React.FC<IFavouriteButtonProps> = ({
  disabled,
  isFavourite = false,
  onChange,
}) => {
  return (
    <Box
      onClick={() => !disabled && onChange(!isFavourite)}
      style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      component="button"
    >
      <Icon.Medium
        icon={isFavourite ? 'star-filled' : 'star'}
        color={isFavourite ? 'champagne1000' : 'grey400'}
      />
    </Box>
  )
}
